// extracted by mini-css-extract-plugin
export default {"tabsContainer":"TabsContainer_tabsContainer__-Whba"};